// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button_clear_filter[data-v-3547ddf9]{margin-left:-10px;margin-right:10px}", "",{"version":3,"sources":["webpack://./resources/client/components/filter/old/FilterButtonClear.vue"],"names":[],"mappings":"AACA,sCAEE,iBAAA,CADA,iBACF","sourcesContent":["\n.button_clear_filter {\n  margin-right: 10px;\n  margin-left: -10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
